import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
// import { crearCategoria, modificarCategoria } from "../../../api/api-categoria";
// import cargandoCard from "../../../components/cargando-card";
// import { obtenerListaCategoria } from "../../../api/api-categoria";
import Select from "react-select";
// import { actualizarProducto, crearProducto } from "../../../api/api-producto";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { actualizarGrupoGeocerca, crearGrupoGeocerca, obtenerGrupoGeocerca } from "../../../api/api-grupo-geocerca";
import { useConceptoGeocerca } from "./concepto-geocerca";

export default function GrupoGeocercaPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  const [listaGrupoGeocerca, setListaGrupoGeocerca] = useState([]);
  const [grupoGeocercaSelected, setGrupoGeocercaSelected] = useState(null);

  const [conceptoGeocercaSelected, setConceptoGeocercaSelected] = useState(null);
  const listaConceptoGeocerca = useConceptoGeocerca();

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      console.log("data");
      console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      const grupoGeocerca = await obtenerGrupoGeocerca();
      setListaGrupoGeocerca(grupoGeocerca.body);
      // console.log("grupoGeocerca");
      // console.log(grupoGeocerca);
      if (data.params.idGrupo !== undefined && data.params.idGrupo !== null) {
        const geocerca = grupoGeocerca.body.find((item) => item.value === data.params.idGrupo);
        setGrupoGeocercaSelected(geocerca);
      }
      if (data.params.idConceptoGeocerca !== undefined && data.params.idConceptoGeocerca !== null) {
        const conceptoGeocerca = listaConceptoGeocerca.find((item) => item.value === data.params.idConceptoGeocerca);
        setConceptoGeocercaSelected(conceptoGeocerca);
      }

      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (conceptoGeocercaSelected === null) {
        message = message + t("alert_debe_seleccionar_concepto_geocerca") + '\n';
      }
      if (grupoGeocercaSelected === null) {
        message = message + t("alert_debe_seleccionar_grupo_geocerca") + '\n';
      }
      if (message.length > 0) {
        showToast(message, "warning", 4000);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    // objEnviar.idCategoria = categoriaSelected !== null ? categoriaSelected.value : null;
    objEnviar.codigo = formData.codigo;
    objEnviar.idGrupo = grupoGeocercaSelected !== null ? grupoGeocercaSelected.value : null;
    objEnviar.nota = formData.nota;
    objEnviar.idConceptoGeocerca = conceptoGeocercaSelected !== null ? conceptoGeocercaSelected.value : null;
    setProcessingVisible(true);
    if (formData.id === 0) {
      // console.log('crear correo');
      const response = await crearGrupoGeocerca(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_creo_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_crear") + "\n" + response.message);
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const response = await actualizarGrupoGeocerca(objEnviar);
      setProcessingVisible(false);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        showToast(t("alert_se_modifico_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_modificar") + "\n" + response.message);
      }
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            {/* <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="categoria">
                  {t("label_categoria")}
                </label>
                <Select options={listaCategoria}
                  isSearchable='true'
                  isClearable='true'
                  value={categoriaSelected}
                  onChange={(event) => setCategoriaSelected(event)}
                  placeholder={t("placeholder_seleccione_categoria")}
                />
              </div>
            </div>
            <br /> */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="concepto-geocerca">
                  {t("label_concepto_geocerca")}<span className="text-red-500">*</span>
                </label>
                <Select options={listaConceptoGeocerca}
                  isSearchable={true}
                  isClearable={true}
                  value={conceptoGeocercaSelected}
                  onChange={(event) => setConceptoGeocercaSelected(event)}
                  placeholder={t("placeholder_seleccione_concepto_geocerca")}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData.codigo}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="grupo-geocerca">
                  {t("label_grupo_geocerca")}<span className="text-red-500">*</span>
                </label>
                <Select options={listaGrupoGeocerca}
                  isSearchable='true'
                  isClearable='true'
                  value={grupoGeocercaSelected}
                  onChange={(event) => setGrupoGeocercaSelected(event)}
                  placeholder={t("placeholder_seleccione_grupo_geocerca")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                    onClick={handleSaveClick}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
